

export const ExposureColors = [
    '#00CD80',
    '#FF5733',
    '#C70039',
]

export const mapExposureColor = (value) => {
  if (value < 30) {
    return ExposureColors[0];
  } else if (value < 60) {
    return ExposureColors[1];
  } else {
    return ExposureColors[2];
  }
};